











import { Component, Vue, Watch } from "vue-property-decorator";
import { MapStoreModule } from "@/store/modules/mapStore";
import { MessageModule } from "@/store/modules/messageModule";

@Component
export default class AppError extends Vue {
  private messages: { [key: string]: string } = {
    requestError: "Oops, that zip code doesn’t seem to be correct."
  };
  get isActive() {
    return MessageModule.isDisplayed;
  }
  get isRequestErrorResponse() {
    return MapStoreModule.isRequestError;
  }
  get message() {
    return MessageModule.message;
  }
  @Watch("isActive")
  hideMessageBar() {
    if (this.isActive) {
      this.closeError();
    }
  }
  @Watch("isRequestErrorResponse")
  hideRequestMessageBar() {
    if (this.isRequestErrorResponse) {
      MessageModule.showMessage({
        message: this.messages.requestError,
        timeout: 2500
      });
      this.closeError();
    }
  }
  private closeError(): void {
    setTimeout(() => {
      MessageModule.hideMessage();
      MapStoreModule.tooggleError(false);
    }, MessageModule.messageTimeout);
  }
}
